import { render, staticRenderFns } from "./CreateBordereauModal.vue?vue&type=template&id=c49520f0&scoped=true&"
import script from "./CreateBordereauModal.vue?vue&type=script&lang=js&"
export * from "./CreateBordereauModal.vue?vue&type=script&lang=js&"
import style0 from "./CreateBordereauModal.vue?vue&type=style&index=0&id=c49520f0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c49520f0",
  null
  
)

export default component.exports